import { Command } from 'commands/Commands';

export class AddAward extends Command {
  type: string = 'Award.Add';

  priority: 100;
}
